import type { FaireProductEntity } from "../../entity_types/product";

export const p_hnmh587qq6: FaireProductEntity = {
  token: "p_hnmh587qq6",
  type: "product",
  name: "Nasturtium Thank You Card",
  brandToken: "b_70lhdy7o",
  brandName: "The Good Twin",
  imageUrl:
    "https://cdn.faire.com/fastly/00cba441a95a9df1b2f57729afdb6d26be40959447b7b7cd4b2a73a288c8ab8f.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.75,
  description:
    "A colorful thank you note.\n\n• Size A2, 4.25 inches by 5.5 inches folded\n• offset printed on bright white paper\n• packed in a cello sleeve with corresponding envelope (color may vary)\n• blank inside, ready for your own special message!\n• printed locally in California, assembled in our Los Angeles studio",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:31.677Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
